module.exports = __webpack_public_path__ + "static/media/taco.7bb6924f.jpg";